import { render } from "./WritingExercises.vue?vue&type=template&id=fb9aa994&ts=true"
import script from "./WritingExercises.vue?vue&type=script&lang=ts"
export * from "./WritingExercises.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__